import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
export const HistoryActions = ({ editorRef, registerEventHandler, }) => {
    const [index, setIndex] = useState(0);
    const [length, setLength] = useState(0);
    const canUndo = index > 0;
    const canRedo = index < length - 1;
    const handleEvent = useCallback(() => {
        var _a;
        const history = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor.history;
        if (!history) {
            return;
        }
        setTimeout(() => {
            setIndex(history.index);
            setLength(history.length);
        }, 200);
    }, [editorRef]);
    useEffect(() => {
        registerEventHandler(handleEvent);
    }, [handleEvent, registerEventHandler]);
    const handleReset = () => {
        var _a, _b;
        (_b = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor.history) === null || _b === void 0 ? void 0 : _b.revert();
    };
    const handleUndo = () => {
        var _a, _b;
        (_b = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor.history) === null || _b === void 0 ? void 0 : _b.undo();
    };
    const handleRedo = () => {
        var _a, _b;
        (_b = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor.history) === null || _b === void 0 ? void 0 : _b.redo();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { isDisabled: !canUndo, mr: 2, onClick: handleReset, variant: "secondary", children: __('Revert to Original') }), _jsx(Button, { "aria-label": __('Undo'), icon: () => (_jsx(FontAwesomeIcon, { height: "16px", iconName: "reply", iconType: CATEGORIES.SOLID })), isDisabled: !canUndo, mr: 2, onClick: handleUndo, variant: "secondary" }), _jsx(Button, { "aria-label": __('Redo'), icon: () => (_jsx(FontAwesomeIcon, { height: "16px", iconName: "share", iconType: CATEGORIES.SOLID })), isDisabled: !canRedo, onClick: handleRedo, variant: "secondary" })] }));
};
//# sourceMappingURL=History.js.map